import {
  Button,
  Col,
  Row,
  Card,
  ButtonToolbar,
  ButtonGroup,
  Form,
} from 'react-bootstrap';
import { useMutation } from '@apollo/client';
import { useParams } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import setFieldTouched from 'final-form-set-field-touched';
import { v4 as uuidv4 } from 'uuid';

import cloneDeep from 'lodash.clonedeep';

import { toastSuccess, toastError } from '../lib/toast_helpers';
import { settingsSet } from '../store/settings_slice';

import { renderOverlay, renderOffline } from '../components/render_helpers';
import SubmitButtonSpinner from '../components/submit_button_spinner';
import Field from '../components/form/rff_field';
import InputField from '../components/form/input_field';
import { coerceInput, handleSubmitError } from '../lib/utils';
import { naskuTokenCreate as naskuTokenCreateMutation } from '../graphql/nasku_token_queries';

const NaskuTokenForm = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const settingsTenant = useSelector((state) => state.settings.tenant);
  const settingsMutating = useSelector((state) => state.settings.mutating);
  const settingsOnline = useSelector((state) => state.settings.online);
  const [naskuTokenCreate] = useMutation(naskuTokenCreateMutation);

  const onFormSubmit = async (data) => {
    const uuid = uuidv4();
    const submitData = cloneDeep(data);
    const mutation = naskuTokenCreate;
    const mutationMessageAction = 'create';
    const input = coerceInput(submitData);
    const mutationData = {
      variables: { input },
      context: {
        serializationKey: settingsTenant,
        tracked: true,
        recordType: 'NaskuTokenType',
        recordId: params.id || uuid,
        mutationType: 'CREATE',
      },
    };
    dispatch(
      settingsSet({
        mutating: true,
      })
    );
    try {
      await mutation(mutationData);
      toastSuccess(`Nasku Token ${mutationMessageAction} succeeded`);
      dispatch(
        settingsSet({
          mutating: false,
        })
      );
    } catch (err) {
      console.log(err);
      const { errorMessage, submitErrors } = handleSubmitError(err);
      dispatch(
        settingsSet({
          mutating: false,
        })
      );
      toastError(errorMessage);
      return submitErrors;
    }
    return undefined;
  };

  const renderContent = () => (
    <>
      <Row className="mt-4 mb-3">
        <Col sm="auto">
          <h1 className="h3 mb-3">Update Nasku Token</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <FinalForm
            onSubmit={(data) => onFormSubmit(data)}
            mutators={{ setFieldTouched }}
          >
            {({ handleSubmit, pristine, submitting }) => (
              <form noValidate>
                <Card>
                  <Card.Body>
                    <Field
                      name="token"
                      component={InputField}
                      labelWidth={4}
                      inputWidth={4}
                      size="lg"
                      asElement="textarea"
                      rows={8}
                    >
                      Token
                    </Field>
                    <Form.Group as={Row}>
                      <Col sm={12}>
                        <ButtonToolbar style={{ justifyContent: 'flex-end' }}>
                          <ButtonGroup className="me-2">
                            <Button
                              type="button"
                              variant="primary"
                              disabled={pristine || submitting}
                              onClick={handleSubmit}
                            >
                              {submitting && <SubmitButtonSpinner />}
                              Save
                            </Button>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </Col>
                    </Form.Group>
                  </Card.Body>
                </Card>
              </form>
            )}
          </FinalForm>
        </Col>
      </Row>
    </>
  );

  return (
    <div>
      {renderOverlay(false, settingsMutating, settingsOnline)}
      {renderOffline(settingsOnline)}
      {renderContent()}
    </div>
  );
};

export default NaskuTokenForm;
